<div class="oauth-authorize">
    <img class="oauth-authorize__brand" src="/assets/aumico-logo-4c.svg" alt="aumico" />

    <div class="oauth-authorize__card" [ngSwitch]="state">
        <ng-container *ngSwitchCase="'loading'">
            <div class="oauth-authorize__spinner" aria-hidden="true"></div>
            <p class="oauth-authorize__muted" data-testid="oauth-authorize-loading">
                {{ 'aumico_oauth_authorize_loading' | i18next }}
            </p>
        </ng-container>

        <ng-container *ngSwitchCase="'redirecting'">
            <div class="oauth-authorize__spinner" aria-hidden="true"></div>
            <p class="oauth-authorize__muted" data-testid="oauth-authorize-redirecting">
                {{ 'aumico_oauth_authorize_redirecting' | i18next }}
            </p>
        </ng-container>

        <ng-container *ngSwitchCase="'consent'">
            <div class="oauth-authorize__handshake" aria-hidden="true">
                <img src="/assets/hamIcons/partner-app-logo.svg" alt="" />
            </div>
            <h1 class="oauth-authorize__title" data-testid="oauth-authorize-consent-title">
                {{
                    (isScopeExtension
                        ? 'aumico_oauth_authorize_consent_extension_title'
                        : 'aumico_oauth_authorize_consent_title'
                    ) | i18next: { clientName: clientName }
                }}
            </h1>
            <p class="oauth-authorize__text">
                {{ 'aumico_oauth_authorize_consent_text' | i18next: { clientName: clientName } }}
            </p>
            <ul class="oauth-authorize__scopes" data-testid="oauth-authorize-scopes">
                <li *ngFor="let scopeKey of consentScopeKeys">{{ scopeKey | i18next }}</li>
            </ul>
            <div class="oauth-authorize__actions">
                <ham-button [disabled]="busy" data-testid="oauth-authorize-approve" (buttonClick)="onApprove()">{{
                    'aumico_oauth_authorize_approve_button' | i18next
                }}</ham-button>
                <ham-button variant="gray" [disabled]="busy" data-testid="oauth-authorize-deny" (buttonClick)="onDeny()">{{
                    'aumico_oauth_authorize_deny_button' | i18next
                }}</ham-button>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'not_admin'">
            <h1 class="oauth-authorize__title" data-testid="oauth-authorize-not-admin">
                {{ 'aumico_oauth_authorize_not_admin_title' | i18next }}
            </h1>
            <p class="oauth-authorize__text">
                {{ 'aumico_oauth_authorize_not_admin_text' | i18next: { clientName: clientName } }}
            </p>
        </ng-container>

        <!-- Errors end HERE, deliberately without any redirect (§2). -->
        <ng-container *ngSwitchCase="'error'">
            <h1 class="oauth-authorize__title oauth-authorize__title--error" data-testid="oauth-authorize-error">
                {{ 'aumico_oauth_authorize_error_title' | i18next }}
            </h1>
            <p class="oauth-authorize__text">{{ errorKey | i18next }}</p>
        </ng-container>
    </div>

    <p class="oauth-authorize__footnote" *ngIf="state === 'consent'">
        {{ 'aumico_oauth_authorize_footnote' | i18next }}
    </p>
</div>
